export const transformResponseInventoryMetrics = metrics => {
  return {
    global_score_percentage: metrics.global_score_percentage,
    total_products: metrics.total_products,
    hs_codes_percentage: metrics.hs_codes_percentage,
    missing_hs_codes_count: metrics.missing_hs_codes_count,
    country_of_origin_percentage: metrics.country_of_origin_percentage,
    missing_country_of_origin_count: metrics.missing_country_of_origin_count,
    weight_percentage: metrics.weight_percentage,
    missing_weight_count: metrics.missing_weight_count,
    unit_cost_percentage: metrics.unit_cost_percentage,
    missing_unit_cost_count: metrics.missing_unit_cost_count,
    export_details_percentage: metrics.export_details_percentage,
    missing_export_details_count: metrics.missing_export_details_count,
    identifiers_percentage: metrics.identifiers_percentage,
    missing_identifiers_count: metrics.missing_identifiers_count,
  }
}
